$(document).ready(function(){
	'use strict';
	if(!document.querySelector('.modal.notification-popup')) return false;
	var countrycode = document.getElementsByTagName("html")[0].getAttribute("data-countrycode");
	var notiPop = {};
		notiPop = function(el){
			// 20200512 START 구유정 || cookieValue 관련 변경
			var $el = $(el),
				cookieName = "noMoreToday_notiPop",
				cookieValue = countrycode + "_" + $el.attr("id"),
				p =  notiPop.prototype;
			
			p.init = function(){
				//if(!$el.find(".modal-check input.check-no-more").length) return;
	
				var getCookie = p.getCookieValue(cookieName) + "";
	
				if(getCookie.indexOf(cookieValue) < 0){
					p.addEvent();
					$el.removeClass("waiting").modal("show");
				}else{
					$el.modal("hide").remove();
				}
			};
	
			p.getCookieValue = function(name){
				var ac = getCookie(name); // common.js
	
				if(ac !== undefined) {
					return ac;
				}else{
					return false;
				}
			};
	
			p.bakeCookie = function(name, isSaveCookie){
				var getCookie = p.getCookieValue(cookieName) + "";
				if(getCookie == "false"){
					isSaveCookie == true ? setCookie(name, cookieValue) : removeCookie(name); // common.js
				}else{
					isSaveCookie == true ? setCookie(name, getCookie + cookieValue) : setCookie(name,  getCookie.split(cookieValue).join());
				}
		
			};
	
	
			p.closeBanner = function(target, isAllClose){
				var target = target || covidPops;
	
				$(target).modal("hide");
	
				if(isAllClose && $('.eprivacy-layer').length){
					$('.eprivacy-layer').remove();
				}
			};
	
			p.addEvent = function(){
				$el.on('hide.bs.modal', function (event) {
					if($('.eprivacy-layer').length) event.preventDefault();
				});
	
				$el.on("click", ".modal-header .modal-close", function(event){
					p.closeBanner(event.delegateTarget, true);
				});
	
				$el.on("click", ".modal-footer button[data-dismiss='modal']", function(event){
					if(typeof ePrivacyCookies=='undefined' || ePrivacyCookies.get('LGCOM_IMPROVEMENTS')) {
		
						p.bakeCookie(cookieName, $el.find(".modal-check input.check-no-more").prop("checked"));
						p.closeBanner(event.delegateTarget, true);
					} else {
		
						if($el.find(".modal-check #checkNoMore").prop("checked")){
							ePrivacyCookies.view('click');	
						}else{
							p.closeBanner(event.delegateTarget, true);
						}
					}
				});
			};
			p.addCloseEvent = function(){
				$el.on("click", "button[data-dismiss='modal']", function(event){
					if(typeof ePrivacyCookies=='undefined' || ePrivacyCookies.get('LGCOM_IMPROVEMENTS')) {
						// Cookie 사용 가능 시 실행할 스크립트
						p.bakeCookie(cookieName,true);
						p.closeBanner(event.delegateTarget, true);
					} else {
						ePrivacyCookies.view('click');
					}
				});
			}
			p.initClose = function(){
				var getCookie = p.getCookieValue(cookieName) + "";
				
				if(getCookie.indexOf(cookieValue) < 0){
					var noticePopTime = $('#noticeEnddate').val();
					if(!!noticePopTime){
						var today = new Date();
						var expiresDate = new Date(noticePopTime);
						if(today < expiresDate){
							p.addCloseEvent();
							$el.removeClass("close-waiting").modal("show");
						}else{
							$el.modal("hide").remove();
						}
					}else{
						p.addCloseEvent();
						$el.removeClass("close-waiting").modal("show");
					}				
				}else{
					$el.modal("hide").remove();
				}
			}
			
			if($(".modal.notification-popup").hasClass('close-24')){
				p.initClose();
			}else{
				p.init();
			}	
		}
		var notificationPops = document.querySelectorAll(".modal.notification-popup");
		$(notificationPops).each(function(){
			notiPop(this);
		});
});